import * as expressionUtils from '../../../utils/surveys/expressions';

const getThresholdScoreText = ({ min, max }: { min?: expressionUtils.Threshold; max?: expressionUtils.Threshold }) => {
  if (min && max) return `${min.text} (${min.value} - ${max.value})`;
  else if (min) return `${min.text} (${min.value})`;

  return '';
};

export { getThresholdScoreText };
